import { defineAttrs as e } from "../../utils/typed-attrs.js";
var t = {
	inline: !0,
	attrs: e({
		uri: { default: "" },
		name: { default: "" }
	}),
	group: "inline",
	selectable: !0,
	parseDOM: [{
		tag: "span.embercom-prosemirror-composer-mention",
		getAttrs(e) {
			return {
				name: e.innerText,
				uri: e.getAttribute("data-uri")
			};
		}
	}],
	toDOM(e) {
		let t = e.attrs;
		return [
			"span",
			{
				class: "embercom-prosemirror-composer-mention",
				"data-uri": t.uri
			},
			t.name
		];
	}
};
//#endregion
export { t as mentionSpec };
